import { baseApi } from "./baseApi";
import { buildPaginationQueryString } from "./queryHelpers";
import { PaginateQuery } from "../../interfaces";

export const skillApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getSkills: builder.query<any, PaginateQuery>({
      query: (data) => buildPaginationQueryString(data, "/api/skill"),
      providesTags: ["Skill"],
    }),
    getSkillsByLesson: builder.query<any, string>({
      query: (lessonId) => `/api/skill/${lessonId}/lesson`,
      providesTags: ["Skill"],
    }),
    getSkillsBySubject: builder.query<any, string>({
      query: (subjectId) => `/api/skill/${subjectId}/subject`,
      providesTags: ["Skill"],
    }),
    getSkill: builder.query<any, string>({
      query: (id) => `/api/skill/${id}`,
      providesTags: ["Skill"],
    }),
    addSkill: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/skill",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Skill"],
    }),
    updateSkill: builder.mutation<any, { id: string; data: any }>({
      query: ({ id, data }) => ({
        url: `/api/skill/${id}`,
        method: "PATCH",
        body: data,
      }),
      invalidatesTags: ["Skill"],
    }),
    deleteSkill: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/skill/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Skill"],
    }),
    getSkillsSuggestion: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/skill/suggest-skills",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Skill"],
    }),
    toggleSkillState: builder.mutation<any, string>({
      query: (id) => ({
        url: `/api/skill/toggle-state/${id}`,
        method: "PATCH",
        body: {},
      }),
      invalidatesTags: ["Skill"],
    }),
    copySkills: builder.mutation<any, any>({
      query: (data) => ({
        url: "/api/skill/copy",
        method: "POST",
        body: data,
      }),
      invalidatesTags: ["Skill"],
    }),
  }),
});

export const {
  useGetSkillsQuery,
  useGetSkillsByLessonQuery,
  useGetSkillsBySubjectQuery,
  useGetSkillQuery,
  useAddSkillMutation,
  useUpdateSkillMutation,
  useDeleteSkillMutation,
  useGetSkillsSuggestionMutation,
  useToggleSkillStateMutation,
  useCopySkillsMutation,
} = skillApi;
